import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, from, empty, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ApiResponse, SingleResultApiResponse } from '../models/api-response.model';
import { AuthService } from './auth.service';
import { UserService } from './user.service';
import { UserInfo } from '../models/user.model';

@Injectable()
export class AuthResolverService implements Resolve<any> {

    constructor(private authService: AuthService, private userService: UserService) {}

    resolve(): Observable<UserInfo> {
        return this.userService.getUserDetails();
    }
}
